module.exports = "<!--\n<p>\n  progress works!\n</p>\n-->\n<div id=\"progressMeterFull\" (click)=\"_videoService.seekVideo($event)\">\n    <div id=\"progressMeter\" (click)=\"_videoService.seekVideo($event)\" [style.width.px]=\"_videoService.calculatedWidth\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/progress/progress.component.html
// module id = ../../../../../src/app/progress/progress.component.html
// module chunks = main